var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-176 -229)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0V18H18V0ZM16.875,16.875H1.125V3.375h15.75ZM1.125,2.25V1.125h15.75V2.25Z",
    transform: "translate(176 229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.925,13.755A2.07,2.07,0,0,1,4.6,11.633H3.574c.037,1.937,1.514,2.992,3.388,2.992,1.725,0,3.053-.931,3.053-2.557A2.053,2.053,0,0,0,8.3,9.9V9.859A1.813,1.813,0,0,0,9.7,8.071c0-1.477-1.253-2.334-2.83-2.334A2.722,2.722,0,0,0,3.859,8.53H4.877a1.834,1.834,0,0,1,1.96-1.974c1.018,0,1.849.558,1.849,1.49,0,.906-.67,1.464-2,1.464H6.167v.807H6.7c1.427,0,2.234.572,2.234,1.652C8.935,13.172,8.1,13.755,6.925,13.755Z",
    transform: "translate(176 229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13,14.438h1.043V5.887h-.807a1.864,1.864,0,0,1-2.1,1.663v.695H13v6.193Z",
    transform: "translate(176 229)",
    fill: "#fff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar-white.ddbc5a8603b04fa378a26a30ddf688f3.svg";